import React, { useRef, useState } from "react";
import Cookies from "js-cookie";
import { Link, useParams } from "react-router-dom";
import { usePartner } from "../../helpers/BrandPageAPI";
import { handleGlobalInputChange } from "../../helpers/functions";
import { MinusIcon, PlusIcon } from "../../assets/svg/ProuductIcons";
import InlineSpinner from "../../components/loading/InlineSpinner";
import ProductModal from "./ProductModal";
import AddCustomizeModal from "../../components/product/AddCustomizeModal";
import cogoToast from "cogo-toast";
import { apiInstance } from "../../helpers/axios";
import { useQueryClient } from "@tanstack/react-query";

const theKey = Cookies.get("kalista-webtoken");
const cookieData = Cookies.get("kalista-web-user");
const customerData = cookieData ? JSON.parse(cookieData) : null;
const customerId = customerData?.Id ? customerData.Id : null;
const customerCode = customerData?.Code ? customerData.Code : null;

const clarityOptions = [
  { id: "YW", name: "Yellow Gold" },
  { id: "W", name: "White Gold" },
  { id: "PW", name: "Pink" },
];
const caratOptions = [
  { id: "10K", name: "10KT" },
  { id: "14K", name: "14KT" },
  { id: "18K", name: "18KT" },
];

const CategoryItem = ({ index, product, prductSizeData, showSizes }) => {

  const { partnerData } = usePartner();
  const ButtonColor = partnerData?.StoreColor;
  const customerStore = useParams();
  const customerLink = customerStore?.UserCode;
  const [modalShow, setModalShow] = useState(false);
  const [displayedGrossWt, setDisplayedGrossWt] = useState(product.NetWt * 0.875);
  const [customizeModalShow, setCustomizeModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    Clarity: "YW",
    Carat: "14K",
    Size:
      product.ItemSize ||
      (Array.isArray(prductSizeData) && prductSizeData.length > 0
        ? prductSizeData[0].CommonMasterName
        : ""),
  });

  const [quantityCount, setQuantityCount] = useState(1);
  const queryClient = useQueryClient();
  const textareaRef = useRef(null);

  const calculateGrossWt = (caratValue) => {
    const baseWeight = product.NetWt;
    switch (caratValue) {
      case "10K":
        return baseWeight * 0.76;
      case "14K":
        return baseWeight * 0.875;
      case "18K":
        return baseWeight;
      default:
        return baseWeight * 0.875;
    }
  };

  const handleInputChange = (e) => {
    handleGlobalInputChange(e, setFormData);

    if (e.target.name === "Carat") {
      setDisplayedGrossWt(calculateGrossWt(e.target.value));
    }
  };

  const handleAddToCart = async (e, product) => {
    e.preventDefault();
    setIsLoading(true);
    const instructions = textareaRef.current
      ? textareaRef.current.value.trim()
      : "";
    const data = {
      CustomerId: customerId,
      CustomerCode: customerCode,
      Quantity: quantityCount,
      CategoryId: product.GrpNo,
      ProductId: product.StyleId,
      StyleCode: product.StyleCode,
      Weight: displayedGrossWt,
      DiamondWt: product.ClientDiamondWt,
      Carat: formData.Carat,
      Color: formData.Clarity,
      CustomizeText: instructions,
      Size: formData.Size,
    };

    try {
      // const response = await apiInstance.post("/Customer/AddCart", data);
      const response = await apiInstance.post("/Partner/AddCart", data);
      if (response.data.Status === true) {
        setCustomizeModalShow(false);
        cogoToast.success(response.data.Message);
        setQuantityCount(1);

        queryClient.invalidateQueries({
          queryKey: ["cartItemCount"],
          exact: false,
        });
        queryClient.invalidateQueries({
          queryKey: ["cartData"],
          exact: false,
        });
      } else {
        cogoToast.error(response.data.Message);
      }
    } catch (error) {
      console.error("API call failed:", error);
      cogoToast.error("Failed to add item to cart.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <React.Fragment key={index}>
        <div className="product-wrap-2 product_card">
          <div className="product-img">
            {product.IsBestSeller && (
              <span className="best_seller_tag">Best Seller</span>
            )}
            <img
              className="default-img"
              src={process.env.REact_APP_IMG_URL + product.ImagePath}
              alt={product.name}
              loading="lazy"
            />
            <div className="details_con">
              <button
                onClick={() => setModalShow(true)}
                className="button primary_btn"
                style={{ background: ButtonColor }}
              >
                QUICK VIEW
              </button>
              <Link
                to={`/${customerLink}/product/${product.StyleCode}`}
                className="button light_outline_btn"
              >
                VIEW DETAILS
              </Link>
            </div>
          </div>
          <div className="product_bottom_con">
            {/* product name */}
            <div className="product_title_con" style={{ "--buttonColor": ButtonColor }}>
              <Link
                to={`/${customerLink}/product/${product.StyleCode}`}
                className="product_title"
              >
                {product.StyleCode}
              </Link>
            </div>

            {/* variant container */}
            <div className="variant_main_con">
              <select
                value={formData.Carat}
                onChange={handleInputChange}
                name="Carat"
                id={"product_Carat_" + product.StyleId}
                className="select_option"
              >
                {caratOptions.map((option) => (
                  <option value={option.id} key={option.id}>
                    {option.name}
                  </option>
                ))}
              </select>
              <select
                value={formData.Clarity}
                onChange={handleInputChange}
                name="Clarity"
                id={"product_Clarity_" + product.StyleId}
                className="select_option"
              >
                {clarityOptions.map((option) => (
                  <option value={option.id} key={option.id}>
                    {option.name}
                  </option>
                ))}
              </select>
              {showSizes !== "false" &&
                ![7, 9, 10, 12, 67, 72, 74, 79].includes(product.GrpNo) && (
                  <select
                    value={formData.Size}
                    onChange={handleInputChange}
                    name="Size"
                    id={"product_Size_" + product.StyleId}
                    className="select_option"
                  >
                    {prductSizeData?.map((option, index) => (
                      <option value={option.CommonMasterName} key={index}>
                        {option.CommonMasterName}
                      </option>
                    ))}
                  </select>
                )}
            </div>

            <div className="qty_main_con">
              {/* qty */}
              <div className="qty_upper_con">
                <span>Qty:</span>
                <div className="product_qty_con">
                  <button
                    onClick={() =>
                      setQuantityCount(
                        quantityCount > 1 ? quantityCount - 1 : 1
                      )
                    }
                    className="dec_qty qty_btn"
                  >
                    <MinusIcon />
                  </button>
                  <input
                    className="qty_number"
                    type="text"
                    value={quantityCount}
                    readOnly
                    name="qty_number"
                  />
                  <button
                    onClick={() => setQuantityCount(quantityCount + 1)}
                    className="inc_qty qty_btn"
                  >
                    <PlusIcon />
                  </button>
                </div>
              </div>
              {/* weight */}
              <div className="product_weight">
                <span>{displayedGrossWt.toFixed(2) || 0} GM</span>{" "}
                <span>|</span>
                <span>{product.ClientDiamondWt || 0} CT</span>
              </div>
            </div>

            {/* buttons */}
            <div className="product-action-2 product_btn_con">
              <button
                onClick={(e) => {
                  handleAddToCart(e, product);
                }}
                className={`button primary_btn`}
                title="Add to cart"
                style={{ background: ButtonColor }}
              >
                {isLoading ? <InlineSpinner /> : "Add to cart"}
              </button>

              <button
                className={`button underline_btn`}
                title="Add Customization"
                onClick={(e) => {
                  setCustomizeModalShow(true);
                }}
              >
                + Add Customization
              </button>
            </div>
          </div>
        </div>
      </React.Fragment >
      <ProductModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        product={product}
        prductSizeData={prductSizeData}
      />
      {
        customizeModalShow && (
          <AddCustomizeModal
            show={customizeModalShow}
            onHide={() => setCustomizeModalShow(false)}
            product={product}
            handleAddToCart={handleAddToCart}
            textareaRef={textareaRef}
            isLoading={isLoading}
          />
        )
      }
    </>
  );
};

export default CategoryItem;
